document.addEventListener("DOMContentLoaded", function () {
    const carousel = document.querySelector(".carousel");
    if (!carousel) return;

    const track = carousel.querySelector(".carousel-track, .procedures-list");
    const items = track ? track.querySelectorAll(":scope > li") : [];
    const prevBtn = document.querySelector(".carousel-btn.prev");
    const nextBtn = document.querySelector(".carousel-btn.next");

    if (!track || !items.length) return;

    let index = 0;
    let itemWidth = 0;
    let maxIndex = 0;
    let itemsVisible = 4;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragging = false;
    let dragDistance = 0;
    const dragThreshold = 6;

    function calc() {
        const w = window.innerWidth;
        itemsVisible = w <= 960 ? 1 : w <= 1180 ? 2 : 4;

        const gap = parseFloat(getComputedStyle(track).gap || 0);
        itemWidth = items[0].offsetWidth + gap;

        maxIndex = Math.max(0, items.length - itemsVisible);
        index = Math.min(index, maxIndex);

        prevTranslate = -index * itemWidth;
        currentTranslate = prevTranslate;

        track.style.transform = `translateX(${prevTranslate}px)`;
        updateButtons();
    }

    function updateButtons() {
        prevBtn.disabled = index === 0;
        nextBtn.disabled = index === maxIndex;
    }

    function goTo(i) {
        index = Math.max(0, Math.min(i, maxIndex));
        prevTranslate = -index * itemWidth;
        currentTranslate = prevTranslate;
        track.style.transition = "transform .3s ease";
        track.style.transform = `translateX(${prevTranslate}px)`;
        updateButtons();
    }

    prevBtn.onclick = () => goTo(index - 1);
    nextBtn.onclick = () => goTo(index + 1);

    function dragStart(x) {
        dragging = true;
        startX = x;
        dragDistance = 0;
        track.style.transition = "none";
        carousel.classList.add("dragging");
    }

    function dragMove(x) {
        if (!dragging) return;
        const delta = x - startX;
        dragDistance = Math.max(dragDistance, Math.abs(delta));
        currentTranslate = prevTranslate + delta;
        track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function dragEnd() {
        if (!dragging) return;
        dragging = false;
        carousel.classList.remove("dragging");
        index = Math.round(Math.abs(currentTranslate) / itemWidth);
        goTo(index);
    }

    carousel.addEventListener("mousedown", e => {
        if (e.button !== 0) return;
        e.preventDefault();
        dragStart(e.clientX);
    });
    window.addEventListener("mousemove", e => {
        if (!dragging) return;
        e.preventDefault();
        dragMove(e.clientX);
    });
    window.addEventListener("mouseup", dragEnd);

    carousel.addEventListener("touchstart", e => dragStart(e.touches[0].clientX));
    carousel.addEventListener("touchmove", e => dragMove(e.touches[0].clientX));
    carousel.addEventListener("touchend", dragEnd);
    carousel.addEventListener("dragstart", e => e.preventDefault());
    carousel.addEventListener("click", e => {
        if (dragDistance > dragThreshold) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    window.addEventListener("resize", calc);
    calc();
});

function initializeHomeSkinProceduresCarousel() {
  const mobileQuery = window.matchMedia('(max-width: 960px)');
  const blocks = document.querySelectorAll('.home-skin .procedures-carousel');

  blocks.forEach((block) => {
    const track = block.querySelector('.procedures');
    const list = track ? track.querySelector('.procedures-list, ul') : null;
    const previousButton = block.querySelector('.procedures-arrow--prev');
    const nextButton = block.querySelector('.procedures-arrow--next');

    if (!track || !list || !previousButton || !nextButton) return;

    const cleanupDesktop = () => {
      list.querySelectorAll('[data-carousel-clone="true"]').forEach((item) => item.remove());
      delete list.dataset.carouselReady;
      track.scrollLeft = 0;
    };

    if (!mobileQuery.matches) {
      cleanupDesktop();
      return;
    }

    if (list.dataset.carouselReady === 'true') return;

    const originalItems = Array.from(list.children);

    if (originalItems.length < 2) {
      previousButton.hidden = true;
      nextButton.hidden = true;
      return;
    }

    const beforeFragment = document.createDocumentFragment();
    const afterFragment = document.createDocumentFragment();

    originalItems.forEach((item) => {
      const beforeClone = item.cloneNode(true);
      const afterClone = item.cloneNode(true);

      beforeClone.setAttribute('aria-hidden', 'true');
      afterClone.setAttribute('aria-hidden', 'true');
      beforeClone.dataset.carouselClone = 'true';
      afterClone.dataset.carouselClone = 'true';
      beforeClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
      afterClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
      beforeFragment.appendChild(beforeClone);
      afterFragment.appendChild(afterClone);
    });

    list.insertBefore(beforeFragment, list.firstChild);
    list.appendChild(afterFragment);
    list.dataset.carouselReady = 'true';

    const getItems = () => Array.from(list.children);
    const getTrackCenter = () => track.scrollLeft + track.clientWidth / 2;
    const getItemCenter = (item) => item.offsetLeft + item.offsetWidth / 2;
    const getOriginalWidth = () => list.children[originalItems.length * 2].offsetLeft - list.children[originalItems.length].offsetLeft;
    const scrollItemToCenter = (item, behavior = 'smooth') => track.scrollTo({ left: getItemCenter(item) - track.clientWidth / 2, behavior });
    const resetToOriginalSet = (behavior = 'auto') => scrollItemToCenter(list.children[originalItems.length], behavior);

    const normalizeLoop = () => {
      const firstOriginalCenter = getItemCenter(list.children[originalItems.length]);
      const firstAfterCenter = getItemCenter(list.children[originalItems.length * 2]);
      const originalWidth = getOriginalWidth();
      const trackCenter = getTrackCenter();

      if (trackCenter < firstOriginalCenter - 8) track.scrollLeft += originalWidth;
      if (trackCenter >= firstAfterCenter - 8) track.scrollLeft -= originalWidth;
    };

    const getCenteredItemIndex = () => {
      const trackCenter = getTrackCenter();

      return getItems().reduce((closestIndex, item, index) => {
        const closestDistance = Math.abs(getItemCenter(list.children[closestIndex]) - trackCenter);
        const itemDistance = Math.abs(getItemCenter(item) - trackCenter);

        return itemDistance < closestDistance ? index : closestIndex;
      }, 0);
    };

    const moveBy = (direction) => {
      normalizeLoop();
      const targetItem = getItems()[getCenteredItemIndex() + direction];
      if (targetItem) scrollItemToCenter(targetItem);
    };

    let snapTimeout;
    const snapToCenteredItem = () => {
      normalizeLoop();
      scrollItemToCenter(list.children[getCenteredItemIndex()]);
    };

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      moveBy(-1);
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      moveBy(1);
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(normalizeLoop);
      window.clearTimeout(snapTimeout);
      snapTimeout = window.setTimeout(snapToCenteredItem, 140);
    });

    window.addEventListener('resize', () => resetToOriginalSet());
    resetToOriginalSet();
  });
}

function readyHomeSkinProceduresCarousel() {
  initializeHomeSkinProceduresCarousel();
  window.matchMedia('(max-width: 960px)').addEventListener('change', initializeHomeSkinProceduresCarousel);

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=home-skin', initializeHomeSkinProceduresCarousel);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', readyHomeSkinProceduresCarousel);
} else {
  readyHomeSkinProceduresCarousel();
}
